export const safeShippingUrl = (value) => {
  if (typeof value !== "string" || value.trim() !== value || /[\u0000-\u001f\u007f\\]/.test(value)) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password
      && (!url.port || url.port === "443") ? url.href : null;
  } catch { return null; }
};
